import axios from "axios";
import { API_BASE } from "../../config/env";

export const FETCH_DELETEATTACHMENT_FULFILLED = "FETCH_DELETEATTACHMENT_FULFILLED";
export const FETCH_DELETEATTACHMENT_REJECTED = "FETCH_DELETEATTACHMENT_REJECTED";
export const FETCH_DELETEATTACHMENT_PENDING = "FETCH_DELETEATTACHMENT_PENDING";
export const RESET_ATTACHMENT = "RESET_ATTACHMENT";


export function deleteAttachmet(applicationId,attachmentId) {
  const token = localStorage.getItem("accessToken")
  return dispatch => {
    dispatch({
      type: "FETCH_DELETEATTACHMENT",
      payload: axios({
        method: "delete",
        url: `${API_BASE}/api/v2/second-opinion/attachment/${applicationId}/${attachmentId}`,

        headers: {
          "Authorization": "Bearer " + token,
          "Accept-Language": "tr-tr",
          "Client-Id": localStorage.getItem("One-Id"),
          "One-Id": localStorage.getItem("Client-Id"),
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning" : "69920"
        },
      }).then((result) => result.data),
    });
  };
}

export function resetDeleteAttachment() {
  return (dispatch) => {
      dispatch({
          type: "RESET_ATTACHMENT",
      });
  };
}